export default __webpack_public_path__ + "static/media/fig-07a-face-log-1.8b2da637.jpg";